export enum Route {
    INS_AND_OUTS_BLOG = 'https://badoo.com/ins-and-outs',
    INDEX = 'https://badoo.com',
    SIGN_IN = 'https://badoo.com/signin',
    SIGN_UP = 'https://badoo.com/signup',
    FORGOT_PASSWORD = 'https://badoo.com/forgot',
}
